import permissions from "app/permissions";
import ListWeeklySchedule from "./List";
import { StudentServicePath, WEEKLY_SCHEDULE } from "utils/constants";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CreateWeeklySchedule from "./Create";

//permissions
export const resources = {
  isMenu: true,
  icon: <NoteAddIcon />,
  name: StudentServicePath + WEEKLY_SCHEDULE,
  title: "Седмично разписание",
  list: <ListWeeklySchedule />,
  create: <CreateWeeklySchedule />,
  createPermission: permissions.canCreateWeeklySchedule,
  permission: permissions.canCreateWeeklySchedule,
};
